<script setup lang="ts">
import { ref } from 'vue'
import { NButton, NModal } from 'naive-ui';
import router from '@/router';
import { useProjectCreateStore } from "@/stores/projects/create.store";
import ProjectForm from "@/components/client/projects/ProjectForm.vue";
import SideBanner from "@/components/utils/SideBanner.vue";
import { ProjectFormData } from "@/ts/interfaces";

const projectCreateStore = useProjectCreateStore()

const showModal = ref<boolean>(false)

const formData = ref<ProjectFormData>({
  role_title: '',
  years_of_experience: null,
  usd_hourly_rate: null,
  job_description: '',
  job_description_link: '',
  skills: [],
  complementary_skills: [],
});

const redirectOnSave = () => {
  router.push({ name: 'client-projects-index' })
}

const submitForm = async () => {
  const response = await projectCreateStore.create(formData.value)

  if(response.ok) {
    showModal.value = true
  }
}
</script>

<template>
  <section class="project-create">
    <div class="grid-x">
      <div class="cell small-12 large-3">
        <side-banner back-route-name="client-projects-index" banner-text="New Project" banner-img="image-new-project.png">
          <template #short-description>
            <div class="short-description body-text">
              Submit a <span class="text-pink text-w-black">new project</span> and start receiving shortlist with selected candidates for your role.
            </div>
          </template>
        </side-banner>
      </div>

      <div class="cell small-12 large-8 x3large-7">
        <project-form :form-data="formData" @submit-action="submitForm"></project-form>
      </div>
    </div>

    <n-modal
      v-model:show="showModal"
      class="project-saved-modal"
      preset="card"
      :style="{ width: '865px' }"
      :bordered="false"
      transform-origin="center"
      size="huge"
      :on-after-leave="redirectOnSave"
    >
      <div class="grid-container">
        <div class="divider"></div>
        <p class="kicker">
          Everything done!
        </p>

        <h1 class="heading h1 text-purple-md success-title">
          Your project has been saved
        </h1>

        <p class="body-text">
          We’ll start sourcing for candidates to present to you, we’ll follow up with you very soon!
        </p>
        <br>
        <p class="body-text">
          You have questions? Schedule a meeting with our Talent Sorcerers
        </p>
        <div class="button-container grid-x align-center">
          <div class="cell small-12 large-6">
            <router-link :to="{ name: 'meetings' }">
              <n-button size="large" :focusable="false">
                SCHEDULE A MEETING
              </n-button>
            </router-link>
          </div>
        </div>
      </div>
    </n-modal>
  </section>
</template>

<style lang="scss">
.project-saved-modal {
  .divider {
    height: 2px;
    width: 254px;
    background: $border-color-gradient;

    margin-bottom: 35px;
  }

  .kicker,.success-title {
    margin-bottom: 25px;
  }

  .button-container {
    margin-top: 60px;
    margin-bottom: 24px;
  }
}
</style>
